<template>
    <div class="formBox">
        <el-dialog :visible.sync="showForm" @close="resetFrom">
            <el-form ref="form" :model="form" label-width="150px">
                <el-col :span="12">
                    <el-form-item :label="$t('gridManage.selectGridArea')">
                        <el-select
                            v-model="form.id"
                            :placeholder="$t('common.selectPlaceholder')"
                            style="width: 100%"
                            @change="setGridArea"
                        >
                            <el-option
                                v-for="item in AreaOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item :label="$t('gridManage.gridSetMethod')">
                        <el-select
                            v-model="form.setModel"
                            :placeholder="$t('gridManage.uploadVectorFile')"
                            style="width: 100%"
                            @change="setModelSelect"
                        >
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item :label="$t('gridManage.uploadVectorFile')">
                        <el-upload
                            ref="upload"
                            drag
                            :action="action"
                            :before-upload="beforeUpload"
                            :on-success="uploadSuccess"
                            multiple
                            style="width: 100%"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">{{ $t('gridManage.dragFileHere') }}<em>{{ $t('gridManage.clickUpload') }}</em></div>
                        </el-upload>
                    </el-form-item>
                </el-col>

                <el-col :span="24" style="text-align: center">
                    <el-button type="primary" style="width: 100px" @click="createGridByShp">{{ $t('common.btnSave') }}</el-button>
                    <el-button style="width: 100px" @click="resetFrom">{{ $t('common.btnCancel') }}</el-button>
                </el-col>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import g from '@global';
import api from '../api.js';

export default {
    props: ['getGridList'],
    data() {
        return {
            showForm: false,
            form: {
                numObj: {},
                setModel: '上传矢量文件',
                filePaths: [],
                id: '',
            },
            options: [
                {
                    value: '上传矢量文件',
                    label: this.$t('gridManage.uploadVectorFile'),
                },
            ],
            AreaOptions: [],
            action: '',
            areaId: null,
        };
    },
    created() {
        this.getAreaList();
    },
    methods: {
        resetFrom() {
            this.form = this.$options.data().form;
            this.$refs.upload.clearFiles();
            this.showForm = false;
        },
        beforeUpload(file) {
            console.log(file);
            let status = false;
            if (this.areaId) status = true;
            return status;
        },
        uploadSuccess(res) {
            this.form.filePaths = [...this.form.filePaths, ...res.data];
        },

        async createGridByShp() {
            let { filePaths, id } = this.form;
            if (!id) {
                this.$message.warning(this.$t('gridManage.selectGridArea'));
                return;
            }
            if (filePaths.length === 0) {
                this.$message.warning(this.$t('gridManage.pleaseUploadVectorFile'));
                return;
            }
            let file = this.form.filePaths.join(',');
            let res = await api
                .createGridByShp({
                    areaId: this.areaId,
                    filePaths: `/${file}`,
                })
                .run();
            this.resetFrom();
            this.getGridList();
        },
        async getAreaList() {
            let res = await api.getAreaList().run();
            let obj = {};
            res.forEach((item) => {
                obj.label = item.name;
                obj.value = item.id;
            });
            this.AreaOptions.push(obj);
        },
        selectColors(e) {
            console.log(e.target.value);
        },
        setModelSelect(val) {
            console.log(val);
        },
        setGridArea(areaId) {
            this.areaId = areaId;
            this.action = `${g.getBaseServer()}/grid/info/upload/${areaId}`;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
    overflow: auto !important;
}
::v-deep .el-popup-parent--hidden {
    padding-right: 0 !important;
}
.formBox {
    box-sizing: border-box;
    padding-right: 20px;
    ::v-deep .el-form {
        .el-upload-dragger,
        .el-upload {
            width: 100%;
        }
    }
}
</style>
